export default {
  id: 'c173032bf4',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page refer-page" data-name="refer">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">Refer &amp; Earn</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="refer-hero">\n                <div class="refer-hero-illust">\n                    <img src="static/img/refer.svg" alt="">\n                </div>\n                <div class="refer-hero-title">';
      r += c(ctx_1.data.offerLine1, ctx_1);
      r += '</div>\n                <div class="refer-hero-sub">';
      r += c(ctx_1.data.offerLine2, ctx_1);
      r += '</div>\n            </div>\n\n            <div class="refer-section-title">Your referral code</div>\n            <div class="refer-code-card">\n                <div class="refer-code">';
      r += c(ctx_1.data.code, ctx_1);
      r += '</div>\n                <button class="refer-code-copy" data-code="';
      r += c(ctx_1.data.code, ctx_1);
      r += '" id="copyCoupon">\n                    <i class="icon f7-icons if-not-md">doc_on_doc_fill</i>\n                    <i class="icon material-icons md-only">content_copy</i>\n                    <span>Copy</span>\n                </button>\n            </div>\n\n            <div class="refer-section-title">Invite friends</div>\n            <div class="refer-share-grid">\n                <button class="refer-share-tile" data-code="';
      r += c(ctx_1.data.shareText, ctx_1);
      r += '" id="whatsAppShare" aria-label="Share on WhatsApp">\n                    <img src="static/img/whatsapp.svg" alt="">\n                    <span>WhatsApp</span>\n                </button>\n                <button class="refer-share-tile" data-code="';
      r += c(ctx_1.data.shareText, ctx_1);
      r += '" id="faceBookShare" aria-label="Share on Facebook">\n                    <img src="static/img/fb.svg" alt="">\n                    <span>Facebook</span>\n                </button>\n                <button class="refer-share-tile" data-code="';
      r += c(ctx_1.data.shareText, ctx_1);
      r += '" id="instaShare" aria-label="Share on Instagram">\n                    <img src="static/img/insta.svg" alt="">\n                    <span>Instagram</span>\n                </button>\n                <button class="refer-share-tile" data-code="';
      r += c(ctx_1.data.shareText, ctx_1);
      r += '" id="anyShare" aria-label="More share options">\n                    <img src="static/img/more.svg" alt="">\n                    <span>More</span>\n                </button>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};